module.exports = __webpack_public_path__ + "resources/img/facetec-id-scan-examples.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-id-scan-examples.png
// module id = 1246
// module chunks = 0